import { getTranslateDOMPositionXY } from 'dom-lib/translateDOMPositionXY';
var translateDOMPositionXY = getTranslateDOMPositionXY({
  enable3DTransform: true
});
export default translateDOMPositionXY;